export const GET_SETTING = "/registration/settings";
export const GET_RULES = "/rules-policies/validate";
export const GET_REGISTRATION = "/registration";
export const GET_USER_INFO = (guid) => `/userinfo/${guid}`;
